<style scoped>
.stickyTab .ivu-tabs > .ivu-tabs-bar {
  margin-bottom: 0;
}
.p-marginer > p {
  padding-bottom: 10px;
}

.volunteer-container {
  display: flex;
  flex-direction: column;
}

.field-container {
  margin-bottom: 10px;
  display: flex;
}

.field-container > .label {
  min-width: 130px;
}

.field-container > .field {
  width: 100%;
}

.group-avatar{
  cursor: pointer;
  height: 60px;
  width: 60px;
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: relative;
}
.group-avatar-important{
  height: 88px !important;
  width:  88px !important;
  top:6px;
  left:6px;
}
.has-margin-bottom {
  margin-bottom: 5px;
}

.upload-avatar{
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000cf;
  position: absolute;
  border-radius: 50%;
  top: 0;
  right: 0;
}

.upload-avatar > button{
  color: #fff;
  font-size: 2em;
}

.header-loader{
  width: 88px;
  height: 88px;
  background: #eaeaea;
}

.content-loader > .content-1{
  height: 18px;
  width: 170px;
  background: #eaeaea;
  border-radius: 4px;
}

.content-loader > .content-2{
  height: 20px;
  width: 125px;
  background: #eaeaea;
  border-radius: 3px;
  margin-top: 10px;
}


</style>

<style lang="scss">
  .hide-ivu-tabs-nav-scroll {
    .ivu-tabs-bar,.ivu-tabs-nav-scroll {
      height: 0 !important;
    }
  }
  .ivu-tabs-nav-wrap.ivu-tabs-nav-scrollable {
    margin-left: 15px;
    margin-right: 15px;
  }

  .invite-content-container > .ivu-radio-group{
    display: flex;
    flex-direction: column;
  }

  .invite-content-container > .ivu-radio-group > label.ivu-radio-wrapper.ivu-radio-group-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    flex-direction: row-reverse;
  }

  .no-highlight.ivu-btn:focus{
    box-shadow: none;
  }

  .no-highlight.ivu-btn-default.ivu-btn.active, .no-highlight.ivu-btn-default.ivu-btn:active{
    border-color: #dddee1;
    color: #495060;
  }

  .no-highlight.ivu-btn-default.ivu-btn.hover, .no-highlight.ivu-btn-default.ivu-btn:hover{
    border-color: #dddee1;
    color: #495060;
  }
</style>

<template>
    <AppLayout class="resources-single-page-template">
        <Row type="flex" justify="center">
            <Col :span="24">
            <!-- {{resourceLoading}} -->
                <Card shadow :padding="0" :style="{borderRadius: '0'}" v-if="'id' in singleResource.data">
                  <div class="flex-container direction-row" v-if="!LoadingResource" style="background-color:transparent;min-height:100px;height:auto;">
                    <!-- <h3>display...</h3> -->
                    <div class="order-1" style="width:100px;background-color:transparent;">
                      <!-- <Col :span="6" style="padding:15px"> -->
                          <!-- <img :src="singleResource.data.thumbnail_photo[0].small"
                              width="100%" alt="IMAGE" style="padding:5px;border:1px solid #ddd"/> -->
                      <div class="group-avatar group-avatar-important">
                        <img class="group-avatar-important" :src="getDisplayImage(singleResource.data)" v-on:click="showVuerSingle($event,'imgViewer',true)" alt="">
                        <img v-show="false" ref="imgViewer" :src="singleResource.data.thumbnail_photo[0].original" width="100%" alt="IMAGE">
                        <div class="upload-avatar" v-if="checkIfUserCanUpdateGroup(singleResource.data)" v-on:click="uploadImage" :loading="imageUploadLoader">
                          <!-- <Button icon="camera" type="text" v-on:click="uploadImage" :loading="imageUploadLoader"></Button> -->
                          <Icon type="camera" style="font-size: 1.4em; color: #fff;"/>
                        </div>
                      </div>
                    </div>
                    <div class="order-2 direction-col" style="width:70%;background-color:transparent;">
                      <div class="order-1" style="padding-top:5px;">
                        <p class="has-margin-bottom">
                          <!-- <span style="float:right;color:red" v-if="checkIfUserCanUpdateGroup(singleResource.data)">
                            <a @click="editMode()"><Icon style="color:red" type="gear-a" size="25"></Icon></a>
                          </span> -->
                          <b>{{singleResource.data.title}}</b>
                          <small style="line-height:15px;display:block" v-if="singleResource.data.type =='admin' || singleResource.data.type =='badge'">{{singleResource.data.description}}</small>
                          <span style="position:absolute;right:15px;top:15px" v-if="singleResource.data.type === 'admin'">
                            <i-button @click="tabName = 'stats'" type="ghost" size="small">
                              <Icon type="pie-graph" size="35"></Icon><br/><small>View Stats</small>
                            </i-button>
                          </span>
                        </p>
                        <Button v-show="isAppCareplan" class="has-margin-bottom no-highlight" size="small" style="margin-right: 5px;width:90px;"
                          :type="singleResource.data.subscribed ? 'default':'primary'"
                          v-if="checkIfCreator(singleResource.data.submitted_by) && isFollowAllow"
                          v-on:click="followGroup" :loading="subsribeLoader">
                          {{subsribeLoader ? '' : singleResource.data.subscribed ? 'Unfollow' : 'Follow'}}
                        </Button>
                        <!-- <Button class="has-margin-bottom no-highlight" size="small" style="margin-right: 5px;width:80px;"
                          :type="singleResource.data.subscribed ? 'default':'primary'"
                          v-if="profileInfo.user_type !== 'guest' && checkIfCreator(singleResource.data.submitted_by) && (singleResource.data.type=='alliance')"
                          v-on:click="followBrand()" :loading="subsribeLoader">
                          {{singleResource.data.subscribed ? 'Unfollow' : 'Follow'}}
                        </Button> -->
                        <!-- <Button class="has-margin-bottom" size="small" v-if="singleResource.data.apply_volunteer && singleResource.data.subscribed && checkIfCreator(singleResource.data.submitted_by)"
                          type="default" v-on:click="volunteerModal = true" style="margin-right: 5px;">Volunteer</Button> -->
                        <!-- <Button class="has-margin-bottom no-highlight" size="small" style="margin-right: 5px;"
                          :type="singleResource.data.subscribed ? 'default':'primary'"
                          v-if="profileInfo.user_type !== 'guest' && checkIfCreator(singleResource.data.submitted_by) && (singleResource.data.type=='event')"
                          v-on:click="followGroup" :loading="subsribeLoader">
                          {{checkIfCreator(singleResource.data.submitted_by) || isUserAdmin(singleResource.data)}}
                        </Button> -->
                        <div style="margin-top: -5px;" :class="[statusDisable ? 'disableEvents':'']" v-if="(singleResource.data.type=='event')">
                          <div>
                            <small> {{dateToPrettyFormat(singleResource.data.pages[0].data.event_start_date)}} </small>
                            <small>at {{timeTo12HourFormat(singleResource.data.pages[0].data.event_start_time)}}</small>
                          </div>
                          <select :disabled="statusDisable" @change="statusClick(statusUser)" v-model="statusUser" style="width:auto" class="ivu-select-selection custom-ui-select has-margin-bottom"
                            v-if="checkIfCreator(singleResource.data.submitted_by) && (singleResource.data.type=='event') && ((singleResource.data.status != null || singleResource.data.subscribed)&& singleResource.data.status != 'decline' && singleResource.data.status != 'pending')">
                              <option :disabled="statusDisable" v-for="item in statusSelect" :value="item.value" :key="item.value">{{ item.label }}</option>
                          </select>
                              <RadioGroup class="has-margin-bottom" v-else @on-change="statusClick(statusUser)" v-model="statusUser" type="button">
                                <Radio :disabled="statusDisable" style="padding:0px 8px" label="accepted">Going</Radio>
                                <Radio :disabled="statusDisable" style="padding:0px 8px" label="interested">Interested</Radio>
                                <Radio :disabled="statusDisable" v-if="singleResource.data.status == 'pending'" style="padding:0px 8px" label="null">Decline</Radio>
                              </RadioGroup>
                        </div>
                          <Button class="has-margin-bottom no-highlight" size="small" style="margin-right: 5px"
                            :type="singleResource.data.subscribed ? 'default':'primary'"
                            v-if="profileInfo.user_type !== 'guest' && (!checkIfCreator(singleResource.data.submitted_by) || isUserAdmin(singleResource.data))"
                            v-on:click="showInvite()">
                            Invite
                          </Button>
                        <!-- <router-link v-if="profileInfo.user_type !== 'guest' && singleResource.data.type !== 'alliance' && singleResource.data.subscribed && singleResource.data.allow_donate" :to="'/donate?rid=' + singleResource.data.id">
                          <Button class="has-margin-bottom" size="small" type="success"><b>Donate</b></Button>
                        </router-link> -->
                        <router-link v-if="profileInfo.user_type !== 'guest' && singleResource.data.type !== 'alliance' && singleResource.data.allow_donate" :to="'/donate?rid=' + singleResource.data.id">
                          <Button class="has-margin-bottom" size="small" type="primary" >Donate</Button>
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <!-- <vue-content-loading :width="300" :height="80" v-if="!LoadingResource">
                    <rect x="12" y="13" rx="0" ry="0" width="50" height="50" />
                    <rect x="80" y="13" rx="4" ry="4" width="100" height="15" />
                    <rect x="80" y="37" rx="4" ry="4" width="50" height="10" />
                  </vue-content-loading> -->
                  <Row type="flex" style="padding: 6px 6px 6px 6px" v-else>
                      <div class="header-loader" style="margin-left"></div>
                      <div class="content-loader">
                        <div class="content-1" style="height: 18px; margin-left: 5px; margin-top:2px"></div>
                        <div v-if="isEvent" class="content-2" style="height:14px; margin-left: 5px; margin-top: 5px"></div>
                        <div v-else class="content-2" style="height:24px; width: 80px; margin-left: 5.5px; margin-top: 5px"></div>
                      </div>
                  </Row>

                </Card>
                <Row type="flex" justify="center">
                  <Col :span="24" v-if="viewSettings && !LoadingResource">
                    <Tabs :animated="false" v-model="tabNameEdit" @on-click="onEditTabClick">
                      <TabPane v-if="singleResource.data.type !== 'report_concern' && singleResource.data.type !== 'artwork'" :label="followTabName" name="followers">
                        <div>
                          <Followers v-if="'id' in singleResource.data" :resource="singleResource.data"></Followers>
                        </div>
                      </TabPane>
                      <!-- <TabPane label="Manage" name="manage">
                          <ManageGroupComponent></ManageGroupComponent>
                      </TabPane>
                      <TabPane label="Moderation" name="moderation">
                          <ModerationComponent :isAdmin="(!checkIfCreator(singleResource.data.submitted_by) || isUserAdmin(singleResource.data))"></ModerationComponent>
                      </TabPane> -->
                    </Tabs>
                  </Col>
                  <Col :span="24">
                    <Affix :offset-top="offsetNo" @on-change="change">
                        <div class="stickyTab" v-if="stickTabs" style="background:rgb(240, 240, 240)">
                          <transition name="mfade">
                            <Tabs :animated="false" v-model="tabName" @on-click="onTabClick">
                              <TabPane label="Posts" name="posts" v-if="singleResource.data.type !== 'badge'"></TabPane>
                              <!-- <TabPane label="Stats" name="stats" v-if="singleResource.data.type === 'admin'"></TabPane> -->
                              <TabPane label="Info" name="info" v-if="!isEcosystem"></TabPane>
                              <!-- <TabPane v-if="singleResource.data.type !== 'badge' && singleResource.data.type !== 'report_concern'" :label="followTabName" name="followers"></TabPane> -->
                              <!-- <TabPane label="Settings" name="settings" v-if="checkIfUserCanUpdateGroup(singleResource.data)"></TabPane> -->
                              <!-- <TabPane label="Invites" name="invites" v-if="checkIfUserCanUpdateGroup(singleResource.data)"></TabPane> -->
                              <!-- <TabPane label="Volunteer" name="volunteer" v-if="checkIfUserCanUpdateGroup(singleResource.data) && singleResource.data.apply_volunteer"></TabPane> -->
                              <TabPane v-if="singleResource.data.type !== 'report_concern' && singleResource.data.type !== 'artwork' && checkIfUserCanUpdateGroup(singleResource.data)" :label="followTabName" name="followers"></TabPane>
                            </Tabs>
                          </transition>
                        </div>
                    </Affix>
                    <div v-show="isEcosystem" style="margin-top:10px;">
                      <PostActivity v-if="!isBroadcast && checkIfUserCanPost(singleResource.data) && singleResource.data.subscribed" view="resource" :page-data="singleResource.data"></PostActivity>
                      <FeedList :isAdmin="(!checkIfCreator(singleResource.data.submitted_by) || isUserAdmin(singleResource.data))" :section="'group'"></FeedList>
                    </div>
                    <Tabs v-show="!isEcosystem" :class="(singleResource.data.type === 'badge') ? 'hide-ivu-tabs-nav-scroll':''" :animated="false" v-model="tabName" @on-click="onTabClick">
                        <TabPane label="Posts" name="posts">
                          <div v-if="tabName == 'posts'">
                            <PostActivity v-if="!isBroadcast && checkIfUserCanPost(singleResource.data) && singleResource.data.subscribed" view="resource" :page-data="singleResource.data"></PostActivity>
                            <FeedList :isAdmin="(!checkIfCreator(singleResource.data.submitted_by) || isUserAdmin(singleResource.data))" :section="'group'"></FeedList>
                          </div>
                        </TabPane>
                        <TabPane label="Info" name="info" v-if="!isEcosystem">
                          <div v-if="tabName === 'info'">
                            <!-- <div style="padding:5px 15px;" v-if="singleResource.data.developer">
                                <p class="p-marginer" style="margin-bottom: 10px;"><b>Created By:</b> {{singleResource.data.creator.display_name}}</p>
                                <p class="p-marginer" v-html="singleResource.data.description"></p>
                            </div> -->

                            <!-- <PagesListComponent :page-info="singleResource.data.pages" v-if="singleResource.type!='event'"></PagesListComponent>
                            <PagesListComponent :page-info="singleResource.pages" v-if="singleResource.type=='event'"></PagesListComponent> -->

                            <!-- <div style="padding:5px 15px;" v-if="singleResource.data.developer">
                              <p class="p-marginer" style="margin-bottom: 10px;"><b>Created By:</b> {{singleResource.data.creator.display_name}}</p>
                            </div> -->
                          <!-- <CourseListComponent
                            :section="'group'"
                            :isInfo="true"
                            :items="singleResource.data.pages"
                          /> -->
                          <GroupInfoPageUI :pages="singleResource.data.pages"/>
                          </div>
                        </TabPane>
                        <TabPane v-if="singleResource.data.type !== 'report_concern' && singleResource.data.type !== 'artwork' && checkIfUserCanUpdateGroup(singleResource.data)" :label="followTabName" name="followers">
                          <div>
                            <Followers v-if="'id' in singleResource.data" :resource="singleResource.data"></Followers>
                          </div>
                        </TabPane>
                        <!-- <TabPane label="Settings" name="settings" v-if="false &&  checkIfUserCanUpdateGroup(singleResource.data)">
                          <div v-if="tabName === 'settings'">
                            <ManageGroupComponent></ManageGroupComponent>
                          </div>
                        </TabPane>
                        <TabPane label="Invites" name="invites" v-if="false && checkIfUserCanUpdateGroup(singleResource.data)">
                          <div v-if="tabName === 'invites'">
                            <PendingInviteComponent></PendingInviteComponent>
                          </div>
                        </TabPane>
                        <TabPane label="Volunteer" name="volunteer" v-if="false && checkIfUserCanUpdateGroup(singleResource.data) && singleResource.data.apply_volunteer">
                          <div v-if="tabName === 'volunteer'">
                            <PendingVolunteerComponent></PendingVolunteerComponent>
                          </div>
                        </TabPane> -->
                    </Tabs>
                    <div class="stat" v-if="tabName == 'stats'">
                      <Stats></Stats>
                    </div>
                  </Col>
                </Row>
            </Col>
        </Row>

        <ModalHolder :title="'Apply as Volunteer'" :is-show="volunteerModal" @on-close="closeModal">
          <template slot="mcontent">
            <div class="volunteer-container">
              <div class="field-container">
                <div class="label">
                  <p class="label-info">Volunteer As</p>
                </div>
                <div class="field">
                  <Select v-model="applyVolunteerForm.data.permission">
                    <Option v-for="(permission, index) in permissions" :value="permission.value" :key="index">{{ permission.label }}</Option>
                  </Select>
                </div>
              </div>
              <div class="field-container">
                <div class="label">
                  <p class="label-info">Reason</p>
                  <small>Reason on why you are qualified for this position.</small>
                </div>
                <div class="field">
                  <Input v-model="applyVolunteerForm.data.qualification" :placeholder="''"
                    type="textarea" :autosize="true"></Input>
                </div>
              </div>
            </div>
          </template>
          <template slot="mfooter">
            <Button type="text" v-on:click="volunteerModal = false">Cancel</Button>
            <Button type="primary" v-on:click="onSubmitVolunteer" :loading="volunteerLoader">Submit</Button>
          </template>
        </ModalHolder>

        <social-sharing :url="shareBrandLink"
          title="Sharpen Founder"
          description=""
          inline-template
          ref="shareFbButton"
          @close="closeModal()">
          <div>
            <network network="facebook">
              <i class="fa fa-facebook" style="display:none"></i>
            </network>
          </div>
        </social-sharing>

        <ModalHolder :title="'Invite others to join'" :is-show="inviteModal"
          :closable="true" :mHeight="'15vh'" @on-close="closeModal">
          <template slot="mheader" class="flex-container direction-row center" style="justify-content:space-between;">
          <div class="order-1"></div>
          <b class="order-2">Invite others to join</b>
          <div class="order-3"></div>
          <img alt=" " @click="inviteModal=false" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;" src="@/assets/close.png">
          </template>
          <template slot="mcontent">
            <div class="invite-content-container">
              <RadioGroup v-model="inviteOption">
                <Radio label="facebook">
                  <div>
                    <span>Facebook Post</span>
                  </div>
                </Radio>
                <Radio label="sms">
                  <div>
                    <span>SMS</span>
                  </div>
                </Radio>
              </RadioGroup>
            </div>
          </template>
          <template slot="mfooter">
                <Button size="large" long v-on:click="onShare" type="primary">Invite</Button>
              </template>
        </ModalHolder>

        <ModalHolder :title="'Invite others to join'" m-height="100%" :is-show="smsInvite">
          <template slot="mheader" class="flex-container direction-row center" style="justify-content:space-between;">
            <div class="order-1"></div>
            <b class="order-2">Invite others to join</b>
            <div class="order-3"></div>
            <img alt=" " @click="smsInvite=false" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;" src="@/assets/close.png">
          </template>
          <template slot="mcontent">
            <share-component :brandId="brandId" @sendInvitation="closeModal" v-if="smsInvite"></share-component>
          </template>
          <template slot="mfooter">
              <Button type="text" @click="closeSmsModal">Cancel</Button>
          </template>
        </ModalHolder>

        <UploadImageComponent ref="uploadImage" @emitBase64="onLoadImage"></UploadImageComponent>
    </AppLayout>
</template>

<script>
import CourseListComponent from "@/components/CourseListComponent";
import UploadImageComponent from '@/components/UploadImageComponent';
import PagesListComponent from "@/components/PagesListComponent";
import FeedList from "@/components/FeedListComponent";
import PostActivity from "@/components/PostActivityComponent";
import Followers from "@/components/ResourcesFollowersListComponent";
import ManageGroupComponent from "@/components/ManageGroupComponent";
import ModalHolder from "@/components/ModalHolderComponent";
import PendingInviteComponent from "@/components/PendingInviteComponent";
import PendingVolunteerComponent from "@/components/PendingVolunteerComponent";
import ModerationComponent from '@/components/ModerationComponent'
import GroupInfoPageUI from '@/components/GroupInfoPageUI'
import Utils from "@/utils.js";
import VueContentLoading from 'vue-content-loading';
import VuerMixin from '@/helpers/vuerMixin'
import ShareComponent from '@/views/ShareComponent'
import Stats from '@/components/statistics'
import * as API from '@/endpoints'
import { mapGetters } from 'vuex'

export default {
  name: "ResourcesSingleComponent",
  components: {
    CourseListComponent,
    FeedList,
    GroupInfoPageUI,
    PostActivity,
    Stats,
    Followers,
    ManageGroupComponent,
    ModalHolder,
    PendingInviteComponent,
    PendingVolunteerComponent,
    PagesListComponent,
    UploadImageComponent,
    VueContentLoading,
    ShareComponent,
    ModerationComponent
  },
  data() {
    return {
      offsetNo: 85,
      viewSettings: false,
      tabName: "posts",
      tabNameEdit: "manage",
      stickTabs: false,
      volunteerModal: false,
      permissions: Cons[0].PERMISSIONS,
      inviteModal: false,
      smsInvite: false,
      inviteOption: 'facebook',
      applyVolunteerForm: {
        volunteerType: "admin",
        title: null,
        type: "apply_volunteer",
        timing: ["now"],
        data_type: "content",
        data: {
          permission: "16",
          qualification: "",
          status: "pending"
        },
        recurrence: [Utils.setRrulePostDate(new Date())]
      },
      statusSelect: [
        {
            value: 'accepted',
            label: 'Going'
        },
        {
            value: 'interested',
            label: 'Interested'
        },
        {
            value:  'null',
            label: 'Not going'
        }],
        statusUser: '',
        previousStatusUser: '',
        statusDisable: false
    };
  },
  watch: {
    $route: function(n, o) {
      if (n) {
        if(!this.LoadingResource){
          this.setTab(n);
        }
        this.viewSettings = (n.query.edit) ? true:false
      }
    },
    LoadingResource: function (val) {
      this.setTab(this.$route);
    }
  },
  computed: {
    ...mapGetters("user", ["brandInfo", "isBroadcast"]),
    ...mapGetters("resource", ["resourceLoading"]),
    isEcosystem() {
      if ( this.singleResource.data.type == 'ecosystem' ) 
        return true;
    },
    isAppCareplan() {
      if ( this.isEcosystem ) 
        return false;
      return ( this.brandInfo.careplan_id == this.singleResource.data.id ) ? false:true;
    },
    isEvent() {
      return this.$route.query.type === "event"
    },
    followTabName() {
      if( this.singleResource.data.type === 'admin' )
        return 'Members';
      if( this.singleResource.data.type === 'event' )
        return 'Followers';
      if( this.singleResource.data.type === 'badge' )
        return 'Awardees';
      return 'Followers';
    },
    isFollowAllow() {
      if( this.singleResource.data.access == 'system' ) return false
      return true
    },
    brandId: {
      get() {
        return this.$store.state.resource.singleResource.data.developed_by;
      }
    },
    singleResource: {
      get() {
        return this.$store.state.resource.singleResource;
      }
    },
    groupFeed: {
      get() {
        return this.$store.state.resource.groupFeed;
      }
    },
    volunteerLoader: {
      get() {
        return this.$store.state.resource.singleResource.volunteerLoader;
      }
    },
    LoadingResource: {
      get() {
        return this.$store.state.resource.singleResource.isLoading;
      }
    },
    subsribeLoader: {
      get() {
        return this.$store.state.resource.singleResource.subscribeLoader;
      }
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    shareBrandLink: {
      get() {
        return API.endpoints.base + '/preview/careplan/' + this.singleResource.data.id + '?inviter_id=' + this.profileInfo.id
        // return this.$store.state.share.shareUrl;
      }
    },
    imageUploadLoader: {
      get() {
        return this.$store.state.publicModule.imageUploadLoader;
      }
    },
    postImageFile: {
      get(){
        return this.$store.state.publicModule.uploadedImage;
      }
    }
  },
  methods: {
    getDisplayImage(data) {
      return Utils.getDisplayImage('group', data, 'small')
    },
    statusClick(v){
      if (this.$store.state.user.info && this.$store.state.user.info.user_type === 'guest') {
        this.$store.commit('hitCheckpoint')
        return false
      }

      if(this.previousStatusUser != v){
        this.statusDisable = true
        if(v == "accepted"){
          this.$store.dispatch("events/joinEvent", this.singleResource.data.id)
          .then(res => {
              this.statusDisable = false
          },error => {
              this.statusDisable = false
          });
        }else if(v == "null"){
          if(this.singleResource.data.invite_id && this.singleResource.data.subscribed){
            this.$store.dispatch("events/declineEvent", this.singleResource.data.invite_id)
            .then(res => {
              this.statusDisable = false
            },error => {
              this.statusDisable = false
            });
          }else{
            this.followGroup()
            this.statusDisable = false
          }
        }else if(v == "interested"){
          if(this.singleResource.data.invite_id){
            this.$store.dispatch('events/setInterestedEvent',  this.singleResource.data.invite_id)
            .then(res => {
              this.statusDisable = false
            },error => {
              this.statusDisable = false
            });
          }else{
            this.followGroup()
            this.statusDisable = false
          }
        }else{
          setTimeout(() => {
            this.statusDisable = false
          }, 1000);
        }
        this.previousStatusUser = v
      }
    },
    editMode() {
      this.$router.push({
        path: this.$route.path,
        query: {
          tab: this.$route.query.tab || 'posts',
          edittab: 'followers',
          edit: 1
        }
      })
    },
    followBrand() {
      if (!this.singleResource.data.subscribed) {
        this.$store.dispatch("resource/followBrandGroup", {group: this.singleResource.data ,userId: this.profileInfo.id, type: 'follow'})
          .then(res => {
            this.singleResource.data.subscribed = true;
          });
      } else {
        this.$store.dispatch("resource/followBrandGroup", {group: this.singleResource.data ,userId: this.profileInfo.id, type: 'unfollow'})
          .then(res => {
            this.singleResource.data.subscribed = false;
          });
      }
    },
    checkIfUserCanPost(data) {
      if (data.members_can_post) {
        return true;
      } else {
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 0
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 511
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 503
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 16
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 49
        )
          return true;
      }

      return false;
    },
    checkIfUserCanUpdateGroup(data) {
      if (data.permission) {
        if ("permission" in data.permission) {
          if (
            data.permission.permission == 511 ||
            data.permission.permission == 503 ||
            data.permission.permission == 99 ||
            data.permission.permission == 0
          )
            return true;
        }
      }
    },
    isUserAdmin(data) {
      if (data.permission) {
        if ("permission" in data.permission) {
          if (
            data.permission.permission == 511 ||
            data.permission.permission == 503 ||
            data.permission.permission == 0
          )
            return true;
        }
      }else{
        return false;
      }
    },
    change(status) {
      this.stickTabs = status;
    },
    setTab(n) {
      console.log(n)
      if( this.singleResource.data.type === 'badge' ) {
        this.tabName = 'followers';
        return false;
      }

      if ("tab" in n.query && n.query.tab)
        this.tabName = n.query.tab;
      // causing overriding the doaction parameters. ----------------------
      // else this.$router.replace({ query: { tab: "posts" } });
      // ------------------------------------------------------------------

      if ("edittab" in n.query && n.query.edittab)
        this.tabNameEdit = n.query.edittab;
    },
    onTabClick(name) {
      // console.log(name)
      // if(name == 'info'){
      //   this.reRoutToInfo()
      // }
      if ("type" in this.$route.query && this.$route.query.type) this.$router.replace({ query: { tab: name,type:  this.$route.query.type } });
      else this.$router.replace({ query: { tab: name}});
    },
    onEditTabClick(name) {
      // console.log(name)
      // if(name == 'info'){
      //   this.reRoutToInfo()
      // }
      if ("type" in this.$route.query && this.$route.query.type) this.$router.replace({ query: { edittab: name,type:  this.$route.query.type, tab: this.$route.query.tab } });
      else this.$router.replace({ query: { edittab: name, tab: this.$route.query.tab, edit: this.$route.query.edit}});
    },
    onSubmitVolunteer() {
      if (this.applyVolunteerForm.data.qualification) {
        this.applyVolunteerForm.title = this.profileInfo.display_name;
        this.$store
          .dispatch("resource/postUpdateVolunteer", {
            data: this.applyVolunteerForm,
            id: this.singleResource.data.id
          })
          .then(res => {
            this.volunteerModal = false;
            this.$Message({
              closable: true,
              durationInSec:10,
              title: { content:'Sent' },
              icon: 'checkmark',
              message: { content: 'Application sent.' },
              buttons: [
                { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
              ]
            });
          });
      } else {
        this.$Message({
          closable: true,
          durationInSec:10,
          title: { content:'Required' },
          icon: 'ios-close',
          message: { content: 'Missing qualification content.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });
      }
    },
    checkIfCreator(id) {
      return !(id == this.profileInfo.id);
    },
    followGroup() {
      if (this.$store.state.user.info && this.$store.state.user.info.user_type === 'guest') {
        this.$store.commit('hitCheckpoint')
        return false
      }

      if (!this.singleResource.data.subscribed) {
        this.$store.dispatch("resource/followGroup", {
          careplan_id: this.singleResource.data.id,
          journal_id: this.profileInfo.journal_id
        });
      } else {
        this.$store.dispatch(
          "resource/unfollowGroup",
          this.singleResource.data.id
        );
      }
    },
    showInvite(){
      this.$store.commit("share/setIsGroupInvite", true)
      this.$store.commit("share/setGroupInviteId", this.singleResource.data.id)
      this.$store.commit("share/setShowInvite", true)
      // this.$store.commit('user/showInviteModal', {showInvite: true,fbShareUrl: this.shareBrandLink})
    },
    closeSmsModal() {
      this.smsInvite = false
      this.inviteModal = true
    },
    closeModal(){
      this.volunteerModal = false
      this.inviteModal = false
      this.smsInvite = false
    },
    onShare() {
      if(this.inviteOption == 'sms'){
        this.inviteModal = false
        this.smsInvite = true
      }else if(this.inviteOption == 'facebook'){
        this.triggerFbShare()
      }
      // this.inviteModal = false
    },
    triggerFbShare($event) {
      // this.$store.dispatch('share/getBrandShareInfo', {brand_id: this.singleResource.data.developed_by, user_id: this.profileInfo.id}).then(res => {
        const elem = this.$refs.shareFbButton
        elem.$el.children[0].click()
      // });
    },
    uploadImage(){
      this.$refs.uploadImage.triggerUpload()
    },
    onLoadImage(image){
      this.$store.commit("base/setLoadingPage", true, {root: 1})
      this.$store.dispatch('publicModule/uploadBase64Image', {base64_image: image})
      .then(res => {
        if(!_.isEmpty(this.postImageFile)){
          let imageContainer = this.singleResource.data.thumbnail_photo
          this.onChangeImage(imageContainer, res.uploaded[0])
        }
      })
      .finally(() => {
        this.$store.commit("base/setLoadingPage", false, {root: 1})
      })
    },
    onChangeImage(oldImage, newImage){
      let payload = this.singleResource.data
      payload.thumbnail_photo = newImage
      payload.thumbnail_photo_uri = newImage
      
      this.$store.dispatch('resource/updateGroupInfo', {id: this.singleResource.data.id, data: payload}).then(res => {
        //fetch group info, because PUT careplan/id doesn't return is not complete i.e missing data.permission
        this.$store.dispatch('resource/getSingleResource', { id: res.id })

        this.$Message({
          closable: true,
          durationInSec:10,
          title: { content:'Updated' },
          icon: 'alert',
          message: { content: 'Group avatar updated.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=>{} }
          ]
        });
      });
    },
    reRoutToInfo(){
      if(this.singleResource.data.pages.length == 1){
        this.$store.commit('feed/setSingleFeed', this.singleResource.data.pages[0])
        this.$router.push({ path: '/feed/' + this.singleResource.data.pages[0].id + "?scroll=false" })
      }
    },
    dateToPrettyFormat(date){
      return Utils.parseDateToPrettyFormat(date)
    },
    timeTo12HourFormat(time){
      return Utils.parseTimeTo12Hr(time)
    }
  },
  beforeCreate() {
    this.$store.commit('resource/setUserGroupFeed', {})
    this.$store.dispatch('resource/getGroupFeed', {
      planId: this.$route.params.planID
    })
    this.$store.dispatch('resource/getPendingResource', this.$route.params.planID )
    if(this.$route.query && this.$route.query.type == 'event'){
      this.$store.dispatch('resource/getSingleEvents', {
        id: this.$route.params.planID
      }).then(res => {
        if (!this.singleResource.data.status && this.singleResource.data.subscribed){
            this.statusUser = 'interested'
        }else{
          this.statusUser = this.singleResource.data.status
        }
        this.previousStatusUser = this.statusUser
      })
    }else{
      this.$store.dispatch('resource/getSingleResource', {
        id: this.$route.params.planID
      }).then(res => {
      })
    }
  },
  mounted() {
    setTimeout(() => {
      // this.setTab(this.$route);
      if( 'edit' in this.$route.query && this.$route.query.edit ) {
        this.viewSettings = this.$route.query.edit
      }
    }, 500)
    if (
      "type" in this.$store.state.mobileView &&
      this.$store.state.mobileView.type === "android"
    )
      this.offsetNo = 0;
    if (
      "type" in this.$store.state.mobileView &&
      this.$store.state.mobileView.type === "ios"
    )
      this.offsetNo = 0;

    this.$store.dispatch('resource/getPendingGroupInvites', this.$route.params.planID);
    this.$store.dispatch('resource/getPendingInviteVolunteer', this.$route.params.planID);
    this.$store.dispatch('events/getEventInvites', this.$route.params.planID);
  },
  mixins: [VuerMixin]
};
</script>
